import React from 'react'
import isEmpty from 'lodash/isEmpty'
import withStyles from 'constructicon/with-styles'
import styles from './styles'

import Buttons from '../Buttons'
import LayoutDefault from './LayoutDefault'
import LayoutLeftSidebar from './LayoutLeftSidebar'
import LayoutRightSidebar from './LayoutRightSidebar'
import RichText from '../RichText'

const Content = ({
  align,
  buttons = [],
  children,
  classNames,
  copy,
  gridSize,
  layout,
  styles,
  subtitle,
  title
}) => {
  // layout can be either
  // - default: just a single column
  // - left: puts the children to the left of the generic content fields
  // - right: puts the children to the right of the generic content fields
  const layouts = {
    left: LayoutLeftSidebar,
    right: LayoutRightSidebar,
    default: LayoutDefault
  }

  const hasOneOf = items => (
    items.some(item => !isEmpty(item) && item[0].text !== '')
  )

  const LayoutComponent = layouts[layout] || LayoutDefault

  // the generic content fields
  const content = hasOneOf([title, subtitle, copy, buttons]) ? (
    <div className='ssb-content'>
      {!isEmpty(title) && <RichText styles={styles.title}>{title}</RichText>}
      {!isEmpty(subtitle) && <RichText styles={styles.subtitle}>{subtitle}</RichText>}
      {!isEmpty(copy) && <RichText styles={styles.copy}>{copy}</RichText>}
      {buttons.length > 0 && <Buttons buttons={buttons} className={classNames.buttons} />}
    </div>
  ) : null

  // put our generic content and children into our chosen layout
  return (
    <LayoutComponent
      align={align}
      content={content}
      gridSize={gridSize}>
      {children}
    </LayoutComponent>
  )
}

export default withStyles(styles)(Content)



// WEBPACK FOOTER //
// ./components/ui/Content/index.js